import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=6637eed6&scoped=true"
import script from "./Kiosk.vue?vue&type=script&lang=ts"
export * from "./Kiosk.vue?vue&type=script&lang=ts"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=6637eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637eed6",
  null
  
)

export default component.exports